import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

const MAX_DISPLAYED_COUNT = 99;

type ChatUnreadBadgeProps = {
  count: number;
  className?: string;
  ariaLabel?: string;
};

const ChatUnreadBadge = ({ count, className, ariaLabel }: ChatUnreadBadgeProps) => {
  const { t } = useTranslation();

  if (count <= 0) return null;

  const displayedCount = count > MAX_DISPLAYED_COUNT ? `${MAX_DISPLAYED_COUNT}+` : count;

  return (
    <div
      className={classNames(
        "pointer-events-none flex items-center justify-center",
        "min-w-[18px] h-[18px] px-1 rounded-full",
        "text-white text-[10px] font-bold leading-none",
        "bg-[linear-gradient(135deg,#ff4d4d_0%,#e63946_100%)]",
        "shadow-[0_2px_6px_rgba(230,57,70,0.4)]",
        className,
      )}
      aria-label={ariaLabel ?? `${t("Unread")}: ${count}`}
    >
      {displayedCount}
    </div>
  );
};

export default ChatUnreadBadge;
